import React, { useEffect } from 'react';
import { useState } from 'react';
import { useSelector } from 'react-redux';

// Component
import SignIn from '../Registration/SignIn';
import SignUp from '../Registration/SignUp';
import ForgotPassword from '../Registration/ForgotPassword';
import MessageUs from '../Registration/MessageUs';

import gtag from 'ga-gtag';

const ContactUs = () => {
    
  //Google Analytics event
  gtag('event','Entered_home_page')

  const [contactStyle1,setContactStyle1] = useState("home-contact-first");
  const [contactStyle2,setContactStyle2] = useState("home-contact-second");
  const [contactStyleDelay,setContactStyleDelay] = useState(false);
  const activePage = useSelector((state) => state.auth.activePage);
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const isSignedIn = useSelector((state) => state.auth.isSignedIn);
  const isForgotPassword = useSelector((state) => state.auth.isForgotPassword);
  const user = useSelector((state) => state.auth.user);
//   console.log("contactUs:isAuthenticated,user = ",isAuthenticated,user);

  function reveal() {
    var reveals = document.querySelectorAll(".reveal");
  
    for (var i = 0; i < reveals.length; i++) {
      var windowHeight = window.innerHeight;
      var elementTop = reveals[i].getBoundingClientRect().top;
      var elementVisible = 150;
  
      if (elementTop < windowHeight 
        - elementVisible
        ) {
        reveals[i].classList.add("active-section");
      } else {
        reveals[i].classList.remove("active-section");
      }
    }
  }

  window.addEventListener("scroll", reveal);

  function hiApp() {
    window.open("https://www.airender.co");
  }

  useEffect(
    () => {
      if( isAuthenticated ) {
        // code to hide welcome message when authenticated and stretch messageUs section in 100% width
        setTimeout(() => {
          setContactStyle1("home-contact-first home-contact-first-authenticated")
          setContactStyle2("home-contact-second home-contact-second-authenticated")
          setContactStyleDelay(true)
        }, 10000);
      } else {
        setContactStyle1("home-contact-first")
        setContactStyle2("home-contact-second")
        setContactStyleDelay(false)
      }
    },
    [isAuthenticated],
  );

  return (
      <div className='home-contact-section'>
        <div className= {isAuthenticated ? contactStyle1 : 'home-contact-first'}>
          <div className= {contactStyleDelay ? 'home-contact-second-authenticated' : 'home-contact-message-title' }>
            Get 
          </div>
          {/* {activePage == "" ? <div className= {contactStyleDelay ? 'home-contact-second-authenticated' : 'home-contact-message-title' }>
            Get 
          </div> : <div style={{opacity:0}} className= {contactStyleDelay ? 'home-contact-second-authenticated' : 'home-contact-message-title' }>
            Get 
          </div> } */}
          {/* <div className={contactStyleDelay ? 'home-contact-message-form home-contact-message-form-authenticate reveal fade-top' : 'home-contact-message-form reveal fade-left'}> */}
          <div className={contactStyleDelay ? 'home-contact-message-form home-contact-message-form-authenticate' : 'home-contact-message-form'}>
            <MessageUs />
          </div>
        </div>
        <div className= {isAuthenticated ? contactStyle2 : 'home-contact-second'}>
          <div className='home-contact-join-title'>
            Started
          </div>
          {/* {activePage == "" ? <div className='home-contact-join-title'>
            Started
          </div> : <div className='home-contact-join-title'>
            ""
          </div> } */}
          { !isAuthenticated
          ? isSignedIn
            // ? <div className='home-contact-join-form reveal fade-right'>
            ? <div className='home-contact-join-form'>
                { isForgotPassword ? <ForgotPassword /> : <SignIn /> }
              </div>
            // : <div className='home-contact-join-form reveal'>
            : <div className='home-contact-join-form'>
                <SignUp />
              </div> 
          : <div className='home-contact-Welcome-form'>
              <div className='home-contact-Welcome-user'> 
                Welcome 
                {/* <br/>
                <div className='home-contact-Welcome-name'> 
                  {user.name} 
                </div>  */}
              </div>
              <div className='home-contact-Welcome-text'> 
                <a className='home-contact-signup-link' 
                    onClick={()=>hiApp()}
                > Click here </a> 
                to checkout the app 
              </div>
            </div>
          }
        </div>
      </div>
  );
}

export default ContactUs;